export default {
    TAB_EVENT_INJECTED: 'tabEventInjected'
};


// WEBPACK FOOTER //
// ./app/constants/SessionStorageKey.js